import { render } from "./AppHero.vue?vue&type=template&id=a82ea840&scoped=true"
import script from "./AppHero.vue?vue&type=script&lang=js"
export * from "./AppHero.vue?vue&type=script&lang=js"

import "./AppHero.vue?vue&type=style&index=0&id=a82ea840&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a82ea840"]])

export default __exports__